<template>
  <div class="editions-page">
    <v-tabs v-model="tab" vertical>
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        @click="currentTab = tab.value"
        :disabled="tab.disable"
        >{{ tab.text }}</v-tab
      >

      <v-tab-item :value="tab" :reverse-transition="false" :transition="false">
        <keep-alive>
          <component :is="currentTabComponent"></component>
        </keep-alive>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
  export default {
    name: "EditionsPage",
    components: {
      AccountingTab: () =>
        import("@/views/editions/components/AccountingTab.vue"),
      WorkshopTab: () => import("@/views/editions/components/WorkshopTab.vue"),
      AdminTab: () => import("@/views/editions/components/AdminTab.vue"),
      InProgressTab: () =>
        import("@/views/editions/components/InProgressTab.vue"),
      TouringBookTab: () =>
        import("@/views/editions/components/TouringBookTab.vue")
    },
    data() {
      return {
        tab: null,
        currentTab: "Accounting",
        tabs: [
          { text: "Comptabilité", value: "Accounting", disable: false },
          { text: "Atelier", value: "Workshop", disable: false },
          { text: "Administration", value: "Admin", disable: false },
          { text: "En cours", value: "InProgress" },
          { text: "Cahier des tournées", value: "TouringBook", disable: false }
        ]
      };
    },
    computed: {
      currentTabComponent() {
        return this.currentTab + "Tab";
      }
    }
  };
</script>

<style lang="scss">
  .editions-page {
    height: 100%;
    .v-tabs {
      height: 100%;
      .v-tab {
        justify-content: flex-start;
      }
      .v-window {
        padding: 15px;
      }
    }
    .v-btn {
      background-color: #006064 !important;
      color: white;
    }
    .filters-container {
      background-color: #f0f0f0;
      padding: 30px;
    }
    .v-data-table {
      table {
        tr {
          background-color: white !important;
          &.v-row-group__header {
            background-color: rgba(132, 31, 99, 0.05) !important;
            .v-btn {
              display: none;
            }
          }
          &:not(.v-row-group__header) {
            td,
            th {
              &:not(:last-child) {
                border-right: 1px solid #707070;
              }
            }
          }
        }
      }
    }

    .selected {
      color: red !important;
    }
  }
</style>
